// PersistMiddlewareLoader.js
'use strict';
import { connect } from 'react-redux';

import PersistMiddlewareLoader from '../component/PersistMiddlewareLoader.jsx';
import getMeData from '../selector/getMeData.js';
import restoreRedux from '../action/restoreRedux.js';
import { PERSIST_NOW } from '../ActionTypes.js';
import postMessageToSwagApp from '../action/postMessageToSwagApp.js';

const mapStateToProps = state => {
  return {
    userId: getMeData(state, 'id'),
    refreshToken: getMeData(state, 'refreshToken'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    restoreRedux: restoreState => dispatch(restoreRedux({ restoreState })),
    persistNow: () => dispatch({ type: PERSIST_NOW }),
    postMessageToSwagApp: payload => dispatch(postMessageToSwagApp(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersistMiddlewareLoader);
